import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown'
import styled from 'styled-components';
import RichText from '@madebyconnor/rich-text-to-jsx';
import cms from 'dw-uk-cms';
import getBrand from 'dw-brand-identify';
import getDeliveryPromiseText from 'dw-uk-common/src/components/deliveryOptions/deliveryMessage';

const gfm = require('remark-gfm')

const brandObj = getBrand();

/**
 * # Item
 * Contains the title and content of the help post
 */
class Service extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cms: {},
			extendedOpeningParagraph: false,
			deliveryMessage: 'Usually delivered within 2-3 days'
		};
	}

	async componentDidMount() {
		const deliveryPromise = await getDeliveryPromiseText().then(data => data);
		this.setState({deliveryMessage: deliveryPromise.deliveryPromiseText});
		this.brandLookup();
	}

	brandLookup() {
		let contentKey;

		switch (brandObj.id) {
			case "stw":
				contentKey = "servicePageStwc";
				break;
			case "avy":
				contentKey = "servicePageAverys";
				break;
			default:
				contentKey = 'servicePage';
		}

		this.getFields(contentKey);
	}

	getFields(contentKey) {
		cms.get(contentKey).then(fields => {
			this.fields = fields;
			this.setState({
				cms: this.fields
			});
		});
	}

	render() {
		return (
			<div>
				<PageTitle>{this.state.cms.pageTitle}</PageTitle>

				{this.state.cms.noticeBox && (
					<Notice>
						<RichText richText={this.state.cms.noticeBox}></RichText>
					</Notice>
				)}

				{/* Display the tony intro block if displayTonyIntro is
				set to true in the CMS */}
				{this.state.cms.displayTonyIntro && (
					<React.Fragment>
					<Tony>
						<div className="openingParagraph">
							{this.state.cms.tonyImage && (
								<div className="tonyImage">
									<img title={this.state.cms.tonyImage.fields.title} alt={this.state.cms.tonyImage.fields.title} src={this.state.cms.tonyImage.fields.file.url} />
								</div>
							)}
							<h3>{this.state.cms.openingTitle}</h3>
							<RichText richText={this.state.cms.openingParagraphSnippet}></RichText>

							{this.state.extendedOpeningParagraph && (
								<div className="openingParagraphExtended">
									<RichText richText={this.state.cms.openingParagraph}></RichText>
								</div>
							)}

							{/* Only display the read more button if the openingParagraph is populated in the CMS */}
							{this.state.cms.openingParagraph && (
								<button onClick={() => {
									this.setState({
										extendedOpeningParagraph: !this.state.extendedOpeningParagraph,
									})
								}}>
									{this.state.extendedOpeningParagraph ? 'Close' : 'Read more'}
								</button>
							)}
						</div>
					</Tony>
					<ClearBoth></ClearBoth>
					</React.Fragment>
				)}

				{this.state.cms.block1Markdown && (
					<Box>
						<h3>Service Status</h3>
						<hr/>
						<p><strong>Standard Delivery</strong>: {this.state.deliveryMessage}. {this.state.cms.standardDeliveryText}</p>
						<ReactMarkdown plugins={[gfm]} children={this.state.cms.block1Markdown} />
					</Box>
				)}

				{this.state.cms.block2Markdown && (
					<Box>
						<ReactMarkdown plugins={[gfm]} children={this.state.cms.block2Markdown} />
					</Box>
				)}

				{this.state.cms.block3Markdown && (
					<Box>
						<ReactMarkdown plugins={[gfm]} children={this.state.cms.block3Markdown} />
					</Box>
				)}

				{this.state.cms.block4Markdown && (
					<Box>
						<ReactMarkdown plugins={[gfm]} children={this.state.cms.block4Markdown} />
					</Box>
				)}

				{this.state.cms.needHelp && (
					<NeedHelp>
						<div>
							<RichText richText={this.state.cms.needHelp}></RichText>
						</div>
						<div className="helpButton">
							<a className="btn btn-primary" href={this.state.cms.needHelpButtonLink}>
								{this.state.cms.needHelpButtonText}
							</a>
						</div>
					</NeedHelp>
				)}
			</div>
		);
	}
}

const PageTitle = styled.h1`
	text-align: center;
	padding: 2rem 0 1rem; 
`;

const Box = styled.div`
	background: white;
	padding: 2rem 5rem;
	margin-bottom: 2rem;
	hr {
		width: 100%;
	}

	table {
		border-collapse: collapse;
		thead th, tbody td {
			border: 1px solid #ddd;
		}
		tbody tr:nth-child(odd) td {
			background: #eee;
		}
	}
`;

const Notice = styled(Box)`
	background: #f2ebce;
`;

const Tony = styled(Box)`
	padding-bottom: 0;
	margin-bottom: 0;
	.tonyImage {
		float:left;
		margin: 0 20px 10px 0;
		@media screen and (max-width: 480px){
			float: none;
			margin: 0 0 10px;
			text-align: center;
		}
	}
	button {
		background: none;
		border: none;
		font-weight: 700;
		padding: 0px;
		&:hover {
			text-decoration: underline;
		}
	}
	.openingParagraphExtended {
		margin-top: 1rem;
	}
`;

const NeedHelp = styled(Box)`
	display: flex;
	align-items: center;
  	justify-content: center;
	background: #eee;
	.helpButton {
		margin-left: 2rem;
		@media screen and (max-width: 767px){ 
			margin: 1rem 0 0; 
		}
	}
	@media screen and (max-width: 767px){
		flex-direction: column;
	}
`;


const ClearBoth = styled.div`
	padding: 2rem 0 0;
	clear: both;
`;

export default Service;